"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnglish = void 0;
const isEnglish = (langCode) => {
    if (!langCode)
        return false;
    const normalized = langCode.toLowerCase();
    return normalized === 'en' || normalized.startsWith('en-');
};
exports.isEnglish = isEnglish;
